import React from 'react';
import PropTypes from 'prop-types';
import './Loader.scss';

const Loader = ({ className }) => (
  <div className={`d-flex justify-content-center align-items-center h-100 ${className}`}>
    <div className="pp-spinner" role="status">
      <span className="sr-only">Loading...</span>
    </div>
  </div>
);

Loader.propTypes = {
  className: PropTypes.string,
};

Loader.defaultProps = {
  className: '',
};

export const LoaderWithText = ({ text }) => (
  <div className="d-flex align-items-center justify-content-center">
    <small className="font-weight-bold">{text}</small>
    <span
      className="pp-spinner -white ml-2"
      role="status"
      aria-hidden="true"
    />
  </div>
);

LoaderWithText.propTypes = {
  text: PropTypes.string,
};

LoaderWithText.defaultProps = {
  text: '',
};

export const CenteredLoader = () => (
  <div className="position-fixed h-100 w-100">
    <Loader />
  </div>
);

export default Loader;
